import script from "./PhotoGalleryEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGalleryEdit.vue?vue&type=script&setup=true&lang=js"

import "./PhotoGalleryEdit.vue?vue&type=style&index=0&id=9020357c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9020357c"]])

export default __exports__